<form (submit)="handleSubmit($event)">
  <div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-container shrink-0"
    >
      <mat-icon class="text-on-primary-container text-[20px]! w-5! h-5!">lock_reset</mat-icon>
    </div>
    <div>
      <h2 class="text-lg font-medium leading-tight">Změnit heslo</h2>
      <p class="text-sm text-on-surface-variant mt-0.5">Zadejte aktuální heslo a zvolte nové</p>
    </div>
  </div>

  <mat-dialog-content>
    <div class="flex flex-col gap-5 pb-4">
      <app-form-field-wrapper fieldName="Aktuální heslo">
        <mat-form-field appearance="outline" class="w-full">
          <mat-icon matPrefix class="text-on-surface-variant mr-1">lock</mat-icon>
          <input
            matInput
            placeholder="••••••••"
            [type]="showCurrentPassword() ? 'text' : 'password'"
            autocomplete="current-password"
            [formField]="passwordForm.currentPassword"
          />
          <button
            matIconButton
            matSuffix
            type="button"
            (click)="showCurrentPassword.set(!showCurrentPassword())"
          >
            <mat-icon>{{ showCurrentPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (
            passwordForm.currentPassword().touched() && passwordForm.currentPassword().invalid()
          ) {
            <mat-error>{{ passwordForm.currentPassword().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>

      <app-form-field-wrapper fieldName="Nové heslo">
        <mat-form-field appearance="outline" class="w-full">
          <mat-icon matPrefix class="text-on-surface-variant mr-1">lock_open</mat-icon>
          <input
            matInput
            placeholder="••••••••"
            [type]="showNewPassword() ? 'text' : 'password'"
            autocomplete="new-password"
            [formField]="passwordForm.newPassword"
          />
          <button
            matIconButton
            matSuffix
            type="button"
            (click)="showNewPassword.set(!showNewPassword())"
          >
            <mat-icon>{{ showNewPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (passwordForm.newPassword().touched() && passwordForm.newPassword().invalid()) {
            <mat-error>{{ passwordForm.newPassword().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>

      <app-form-field-wrapper fieldName="Potvrdit nové heslo">
        <mat-form-field appearance="outline" class="w-full">
          <mat-icon matPrefix class="text-on-surface-variant mr-1">lock_open</mat-icon>
          <input
            matInput
            placeholder="••••••••"
            [type]="showConfirmPassword() ? 'text' : 'password'"
            autocomplete="new-password"
            [formField]="passwordForm.confirmPassword"
          />
          <button
            matIconButton
            matSuffix
            type="button"
            (click)="showConfirmPassword.set(!showConfirmPassword())"
          >
            <mat-icon>{{ showConfirmPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (
            passwordForm.confirmPassword().touched() && passwordForm.confirmPassword().invalid()
          ) {
            <mat-error>{{ passwordForm.confirmPassword().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>
    </div>
  </mat-dialog-content>

  <app-dialog-error-bar [message]="submission.errorMessage()" />

  <mat-dialog-actions align="end" class="border-t border-outline-variant!">
    <button matButton type="button" [disabled]="submission.isSaving()" (click)="dialogRef.close()">
      Zrušit
    </button>
    <button matButton="filled" type="submit" [disabled]="submission.isSaving()">
      @if (submission.isSaving()) {
        Ukládám…
      } @else {
        Změnit heslo
      }
    </button>
  </mat-dialog-actions>
</form>
